import {LazyLoadWrapper} from '../../../lazyLoad/LazyLoadWrapper';
import Layout from './Layouts';

interface Props {
  id: string;
  className?: string;
}

function PageLayout(props: Props) {
  return (
    <LazyLoadWrapper>
      <Layout {...props} />
    </LazyLoadWrapper>
  );
}

export default PageLayout;
